/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Sprache } from '../models';
/**
 * SpracheService - axios parameter creator
 * @export
 */
export const SpracheServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von  Sprachen
         * @summary Sprachen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSprachen: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sprachen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert die DefaultSprache
         * @summary Sprachen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultSprache: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sprachen/default`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Sprache
         * @summary Sprachen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpracheById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSpracheById', 'id', id)
            const localVarPath = `/api/sprachen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpracheService - functional programming interface
 * @export
 */
export const SpracheServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpracheServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von  Sprachen
         * @summary Sprachen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSprachen(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sprache>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSprachen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert die DefaultSprache
         * @summary Sprachen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultSprache(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sprache>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultSprache(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Sprache
         * @summary Sprachen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpracheById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sprache>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpracheById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SpracheService - factory interface
 * @export
 */
export const SpracheServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpracheServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von  Sprachen
         * @summary Sprachen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSprachen(options?: any): AxiosPromise<Array<Sprache>> {
            return localVarFp.getAllSprachen(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert die DefaultSprache
         * @summary Sprachen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultSprache(options?: any): AxiosPromise<Sprache> {
            return localVarFp.getDefaultSprache(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Sprache
         * @summary Sprachen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpracheById(id: number, options?: any): AxiosPromise<Sprache> {
            return localVarFp.getSpracheById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SpracheService - interface
 * @export
 * @interface SpracheService
 */
export interface SpracheServiceInterface {
    /**
     * Liefert eine Liste von  Sprachen
     * @summary Sprachen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpracheServiceInterface
     */
    getAllSprachen(options?: any): AxiosPromise<Array<Sprache>>;

    /**
     * Liefert die DefaultSprache
     * @summary Sprachen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpracheServiceInterface
     */
    getDefaultSprache(options?: any): AxiosPromise<Sprache>;

    /**
     * Liefert eine Sprache
     * @summary Sprachen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpracheServiceInterface
     */
    getSpracheById(id: number, options?: any): AxiosPromise<Sprache>;

}

/**
 * SpracheService - object-oriented interface
 * @export
 * @class SpracheService
 * @extends {BaseAPI}
 */
export class SpracheService extends BaseAPI implements SpracheServiceInterface {
    /**
     * Liefert eine Liste von  Sprachen
     * @summary Sprachen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpracheService
     */
    public getAllSprachen(options?: any) {
        return SpracheServiceFp(this.configuration).getAllSprachen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert die DefaultSprache
     * @summary Sprachen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpracheService
     */
    public getDefaultSprache(options?: any) {
        return SpracheServiceFp(this.configuration).getDefaultSprache(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Sprache
     * @summary Sprachen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpracheService
     */
    public getSpracheById(id: number, options?: any) {
        return SpracheServiceFp(this.configuration).getSpracheById(id, options).then((request) => request(this.axios, this.basePath));
    }
}
